import Vue from 'vue'
import Vuex from 'vuex'
import {LOGIN} from './mutation-types'
import axios from 'axios'
import _ from "lodash"
import qs from 'qs'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loginObj: {
      grant_type: "password"
      , scope: "all"
      , client_id: "90101"
      , client_secret: "3a1184ef-992f-41cf-aabd-86c6b547ef20"
    }
  }
  , mutations: {}
  , actions: {
    [LOGIN]({state}, {username, password, image_vertiy_code}) {
      let data = _.extend({username, password, image_vertiy_code}, state.loginObj);
      return axios({
        url: "/oauth2/oauth/token"
        , method: "post"
        , data
        , transformRequest: [function (data) {
          let ret = '';
          for (let it in data) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
          return ret
        }]
        , headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
    }

    , login2(Store, {username, password, alliance}) {
      let data = {
        username: username + alliance,
        showname: username,
        password: password

      }

      return axios({
        url: "/jcp/api/sub/league/login", method: "post"
        , data: qs.stringify(data)
        , headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(() => {
        window.location.href = "/jcp/admin"
      })
    }

    , getPhoneCode(none, {phone, tmpAccessToken}) {
      let params = {phone, tmpAccessToken}
      return axios.get(`/oauth2/oauth/unchecked/vertify/code`, {params}).then(result => result.data)
    }
    , verifyLogin(none, {phone, tmpAccessToken, vertfiyCode}) {
      let data = {
        phone, vertfiyCode, tmpToken: tmpAccessToken
      }
      let formData = new FormData();
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          formData.append(key, data[key]);
        }
      }


      return axios({
        url: '/oauth2/oauth/login_sms_confirm'
        , method: "post"
        , data
        , transformRequest: [(data) => {
          let ret = '';
          for (let it in data) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
          return ret
        }]
        , headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
    }

  }
})
